import { Component } from '@theme/component';

class EvermarkdTeamOrder extends Component {
  #controller;
  #variants;
  #selection;
  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }
  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }
  #bind() {
    this.#variants = undefined;
    this.#selection = undefined;
    this.#controller?.abort();
    this.#controller = new AbortController();
    const enhanced = this.querySelector('[data-team-enhanced]');
    if (enhanced) {
      // Section updates may retain the previous form nodes. Reset before parsing.
      enhanced.hidden = true;
      const fallback = this.querySelector('[data-team-fallback]');
      if (fallback) fallback.hidden = false;
      const input = this.querySelector('input[name="id"]');
      if (input instanceof HTMLInputElement) input.value = '';
      const button = this.querySelector('button[type="submit"]');
      if (button instanceof HTMLButtonElement) button.disabled = true;
    }
    this.addEventListener('submit', this.#validateSubmit, { signal: this.#controller.signal });
    const script = this.querySelector('[data-team-variants]');
    if (script) {
      try { this.#variants = JSON.parse(script.textContent); }
      catch { return; }
      if (!Array.isArray(this.#variants) || this.#variants.length !== 160) return;
    } else if (enhanced) return;
    this.addEventListener('change', this.#update, { signal: this.#controller.signal });
    this.#update();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }
  #validateSubmit = event => {
    if (this.querySelector('[data-team-enhanced]')?.hidden) {
      event.preventDefault();
      return;
    }
    this.#update();
    if (this.#variants && (!this.querySelector('input[name="id"]')?.value || this.querySelector('button[type="submit"]')?.disabled)) event.preventDefault();
  };
  #update = () => {
    let rules;
    if (this.#variants) {
      const color = this.querySelector('.em-team-colors__radio:checked')?.value;
      const shape = this.querySelector('[data-team-shape]')?.value;
      const artwork = this.querySelector('[data-team-artwork]')?.value;
      const variant = this.#variants.find(item => item.option1 === color && item.option2 === shape && item.option3 === artwork);
      const input = this.querySelector('input[name="id"]');
      const button = this.querySelector('button[type="submit"]');
      if (!(input instanceof HTMLInputElement) || !(button instanceof HTMLButtonElement)) return;
      input.value = variant?.available ? String(variant.id) : '';
      button.disabled = !variant?.available;
      button.textContent = variant?.available ? this.dataset.addLabel : variant ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
      const status = this.querySelector('[data-team-selection-status]');
      if (status) status.textContent = variant?.available ? '' : variant ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
      if (!variant) return;
      const enhanced = this.querySelector('[data-team-enhanced]');
      const fallback = this.querySelector('[data-team-fallback]');
      if (enhanced) enhanced.hidden = false;
      if (fallback) fallback.hidden = true;
      rules = variant.quantity_rule;
      const selection = JSON.stringify([color, shape, artwork]);
      if (selection !== this.#selection) {
        this.#selection = selection;
        this.dispatchEvent(new CustomEvent('evermarkd:team-selection', { bubbles: true, detail: { color, shape, artwork } }));
      }
    } else {
      const selected = this.querySelector('input[name="id"]:checked');
      if (!(selected instanceof HTMLInputElement)) return;
      rules = { min: selected.dataset.quantityMin, increment: selected.dataset.quantityStep, max: selected.dataset.quantityMax };
    }
    const quantity = this.querySelector('input[name="quantity"]');
    if (!(quantity instanceof HTMLInputElement)) return;
    const min = Number(rules?.min) || 1;
    const step = Number(rules?.increment) || 1;
    const max = Number(rules?.max) || Infinity;
    quantity.min = String(min);
    quantity.step = String(step);
    if (Number.isFinite(max)) quantity.max = String(max);
    else quantity.removeAttribute('max');
    const current = Number(quantity.value) || min;
    const snapped = min + Math.floor((Math.max(min, current) - min) / step) * step;
    quantity.value = String(Math.max(min, Math.min(max, snapped)));
  };
}
if (!customElements.get('evermarkd-team-order')) customElements.define('evermarkd-team-order', EvermarkdTeamOrder);

